import { memo, type ReactNode } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface DataTablePaginationInfoProps {
  startItem: number
  endItem: number
  totalCount: number
  pageSize: number
  pageSizeOptionList: number[]
  onPageSizeChange?: (value: string) => void
}

/**
 * Displays pagination info including item range and page size selector.
 */
const DataTablePaginationInfoBase: React.FC<DataTablePaginationInfoProps> = ({
  startItem,
  endItem,
  totalCount,
  pageSize,
  pageSizeOptionList,
  onPageSizeChange,
}): ReactNode => (
  <div className="data-table-pagination-info flex items-center gap-2 text-sm text-muted-foreground">
    <span>
      Showing {startItem}-{endItem} of {totalCount}
    </span>
    {onPageSizeChange && (
      <>
        <span className="mx-2">|</span>
        <span>Rows per page</span>
        <Select value={pageSize.toString()} onValueChange={onPageSizeChange}>
          <SelectTrigger className="data-table-page-size-select h-8 w-[70px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {pageSizeOptionList.map((size) => (
              <SelectItem key={size} value={size.toString()}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </>
    )}
  </div>
)

export const DataTablePaginationInfo = memo(DataTablePaginationInfoBase)

DataTablePaginationInfo.displayName = 'DataTablePaginationInfo'
